import React from "react";
import styled from "styled-components";

const LoadingWrapper = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LoadingMessage = styled.h1`
  font-size: 2rem;
  color: #666;
`;

export default function Loader() {
  return (
    <LoadingWrapper>
      <LoadingMessage>Loading...</LoadingMessage>
    </LoadingWrapper>
  );
}
